// Copyright © 2025 CATTLEytics Inc.

/**
 * WARNING!
 *
 * DO NOT EDIT THIS FILE
 *
 * CHANGES WILL BE OVERWRITTEN!
 *
 * Make changes in packages/shared and run npm run copy-shared-to-packages
 */

import { differenceInDays, intervalToDuration, parseISO } from 'date-fns';

export function calcAgeDisplay(birthDate: string, lactation: number, gender: string): string {
  if (!birthDate) {
    return '-';
  }
  const isMale = gender?.toLowerCase() === 'male';

  const startDate = parseISO(birthDate);
  const todayDate = new Date();
  const totalDuration = intervalToDuration({ start: startDate, end: todayDate });

  const days = totalDuration.days ?? 0;
  const months = totalDuration.months ?? 0;
  const years = totalDuration.years ?? 0;

  if (isMale || lactation === 0) {
    const monthValue = years * 12 + months + days / 30;
    const totalDays = differenceInDays(todayDate, startDate);
    return `${monthValue.toFixed(1)} months (${totalDays} days)`;
  }

  return `${years} years`;
}
